import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  CircularProgress
} from '@mui/material';
import { useTechnicians } from '../../contexts/TechniciansContext';

const TechnicianSelect = ({ value, onChange, error, helperText }) => {
  const { technicians, loading } = useTechnicians();

  return (
    <FormControl fullWidth error={Boolean(error)}>
      <InputLabel id="technician-select-label">Technicien</InputLabel>
      <Select
        labelId="technician-select-label"
        value={value}
        onChange={onChange}
        label="Technicien"
        disabled={loading}
        MenuProps={{
          sx: {
            zIndex: 1600
          },
          PaperProps: {
            sx: {
              zIndex: 1600
            }
          }
        }}
      >
        {loading ? (
          <MenuItem disabled>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            Chargement des techniciens...
          </MenuItem>
        ) : (
          technicians.map((technician) => (
            <MenuItem key={technician.id} value={technician.id}>
              {`${technician.firstName} ${technician.lastName}`}
            </MenuItem>
          ))
        )}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default TechnicianSelect; 